import { useEffect } from 'react';

export const WHATSAPP_NUMBER = '5516991237391';
export const INSTAGRAM_URL =
    'https://www.instagram.com/brunovitaltattoo?utm_source=ig_web_button_share_sheet&cplk=ZDNlZDc0MzIxNw==';
export const MAPS_URL = 'https://maps.app.goo.gl/4uVFkkeMaaJ2THwC6';

export const getWhatsappUrl = (mensagem: string) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(mensagem)}`;

export const WHATSAPP_DEFAULT = getWhatsappUrl(
    'Olá, vim pelo link na bio e gostaria de mais informações...'
);

export const useBrunoBackground = () => {
    useEffect(() => {
        const html = document.documentElement;
        const body = document.body;
        const root = document.getElementById('root');
        const prevHtml = html.style.backgroundColor;
        const prevBody = body.style.backgroundColor;
        const prevRoot = root?.style.backgroundColor ?? '';

        html.style.backgroundColor = '#000000';
        body.style.backgroundColor = '#000000';
        if (root) root.style.backgroundColor = '#000000';

        return () => {
            html.style.backgroundColor = prevHtml;
            body.style.backgroundColor = prevBody;
            if (root) root.style.backgroundColor = prevRoot;
        };
    }, []);
};
